import { Resources } from 'constants/resources';

import { useMutation } from '@tanstack/react-query';
import { SaveUsersMerchantAccessParams, saveUsersMerchantAccess } from 'config/requests/users';
import { queryClient } from 'providers/queryClient';
import { useNotify } from 'react-admin';

type ApiError = {
  data?: {
    errors?: { title?: string }[];
  };
};

export const useSaveUsersMerchantAccesses = (onSuccessClose: () => void) => {
  const notify = useNotify();

  return useMutation<unknown, ApiError, SaveUsersMerchantAccessParams>({
    mutationKey: [Resources.Users, 'merchant-access'],
    mutationFn: saveUsersMerchantAccess,

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [Resources.Users] });

      notify('Настройки доступа успешно изменены!', {
        type: 'info',
      });

      onSuccessClose();
    },

    onError: (error) => {
      const message = error?.data?.errors?.[0]?.title ?? 'Ошибка сервера';

      notify(message, { type: 'error' });
    },
  });
};
